// extracted by mini-css-extract-plugin
export default {"search-loading":"Y92_cy","search-loading__background":"_BRsZG","search-loading__content":"sCbwLk","search-loading__text":"iewb9l","search-loading__placeholder":"veY53d"};